import { getRequest, postRequest } from './request'

export const getWxConfig = data => getRequest("/web/ncxtyjrwork/index.php/Api/Common/getWxConfig", data);



// WEBPACK FOOTER //
// ./src/api/apiData.js